import { css } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import theme from '../theme';

export default function Toast ({type, children}) {
  const hasError = type == 'error';
  const [finish, setFinish] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFinish(true);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);

  return !finish && (
    <div css={css`position: fixed; bottom: 2rem; left: 2rem; right: 2rem;  color: white; text-align: center;`}>
      <div css={css`display: inline-flex; background-color: ${hasError ? theme.colors.error : theme.colors.success}; padding: 0.5rem 1rem; border-radius: 0.5rem; align-items: center`}>
        <span className="material-icons" css={css`margin-right: 0.5rem`}>error_outline</span>
        {children}
        <span className="material-icons" css={css`margin-left: 2rem; cursor: pointer`} onClick={() => setFinish(true)}>close</span>
      </div>
    </div>
  );
};
